var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_716_6774",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_716_6774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.83325 16.3333V14.6667H5.49992V8.83332C5.49992 7.68055 5.84714 6.6561 6.54159 5.75999C7.23603 4.86443 8.13881 4.27777 9.24992 3.99999V3.41666C9.24992 3.06943 9.37158 2.77443 9.61492 2.53166C9.8577 2.28832 10.1527 2.16666 10.4999 2.16666C10.8471 2.16666 11.1421 2.28832 11.3849 2.53166C11.6283 2.77443 11.7499 3.06943 11.7499 3.41666V3.99999C12.861 4.27777 13.7638 4.86443 14.4583 5.75999C15.1527 6.6561 15.4999 7.68055 15.4999 8.83332V14.6667H17.1666V16.3333H3.83325ZM10.4999 18.8333C10.0416 18.8333 9.64936 18.6703 9.32325 18.3442C8.99659 18.0175 8.83325 17.625 8.83325 17.1667H12.1666C12.1666 17.625 12.0035 18.0175 11.6774 18.3442C11.3508 18.6703 10.9583 18.8333 10.4999 18.8333ZM7.16659 14.6667H13.8333V8.83332C13.8333 7.91666 13.5069 7.13193 12.8541 6.47916C12.2013 5.82638 11.4166 5.49999 10.4999 5.49999C9.58325 5.49999 8.79853 5.82638 8.14575 6.47916C7.49297 7.13193 7.16659 7.91666 7.16659 8.83332V14.6667Z",
    fill: "#594AE3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotification);
export default __webpack_public_path__ + "static/media/icon-notification.e2251cc4a8bd1a6972300e5d956e036d.svg";
export { ForwardRef as ReactComponent };